module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Search By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Member (Type Here)")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "filterable": false,
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "search": _vm.getMemberRecords,
      "input": _vm.getRecordMemberWise
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "member_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Disbursement Date From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementStartDate),
      expression: "form.disbursementStartDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "disbursementStartDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.disbursementStartDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementStartDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Disbursement Date To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementEndDate),
      expression: "form.disbursementEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "disbursementEndDate",
      "placeholder": "Disbursment End Date"
    },
    domProps: {
      "value": (_vm.form.disbursementEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("EMI End Date From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.startEmiEndDate),
      expression: "form.startEmiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "startEmiEndDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.startEmiEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "startEmiEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("EMI End Date To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.endEmiEndDate),
      expression: "form.endEmiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "endEmiEndDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.endEmiEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "endEmiEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Select Branch")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadStaff]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                Select Company Branch\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                " + _vm._s(branch.name) + "\n              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), (_vm.canAccess('loan-disbursement-update')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Staff"
    },
    on: {
      "input": _vm.getRecordByStaff
    },
    model: {
      value: (_vm.staf),
      callback: function($$v) {
        _vm.staf = $$v
      },
      expression: "staf"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1)]) : _vm._e()])])]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.member_loan_plan) ? _c('span', [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planName(row.plan)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.planCategory))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planRecoveryType(row.plan)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.planAmt(row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.disAmt(row)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.disbursementDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.emiStartDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.emiEndDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member.alias))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.agent) ? _c('span', [_vm._v(_vm._s(row.agent.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.branch) ? _c('span', [_vm._v(_vm._s(row.branch.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.branch_center) ? _c('span', [_vm._v(_vm._s(row.branch_center.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.branch_ledger) ? _c('span', [_vm._v(_vm._s(row.branch_ledger.ledger.name))]) : _vm._e(), _vm._v(" "), (row.head_office_branch_ledger) ? _c('span', [_vm._v(_vm._s(row.head_office_branch_ledger.ledger.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [_vm._m(4, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu dropdown-menu-right",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "Previous Loan"
      },
      on: {
        "click": function($event) {
          return _vm.viewPreviousLoanRecords(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-leanpub"
    }), _vm._v(" Previous Loan\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-create') && (row.advance_emi_security === '' || row.advance_emi_security === null)) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.advanceSecurity(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Advance Security\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.status == 'disbursed' || row.status == 'pending'),
        expression: "row.status == 'disbursed' || row.status == 'pending'"
      }],
      on: {
        "click": function($event) {
          return _vm.deleteDisbursment(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete\n                        ")])]) : _vm._e(), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.filechargeStatus == 'exclude'),
        expression: "row.filechargeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "File Charge"
      },
      on: {
        "click": function($event) {
          return _vm.fileChargeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    }), _vm._v(" File Charge\n                        ")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.processingFeeStatus == 'exclude'),
        expression: "row.processingFeeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "Processing Fee"
      },
      on: {
        "click": function($event) {
          return _vm.processingFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-hourglass"
    }), _vm._v(" Processing Fee\n                        ")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.insuranceFeeStatus == 'exclude'),
        expression: "row.insuranceFeeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "Insurance Fee"
      },
      on: {
        "click": function($event) {
          return _vm.insuranceFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-md"
    }), _vm._v(" Insurance Fee\n                        ")])]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "For Staff"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    }), _vm._v(" Loan Agreement\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "For Customer"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintCustomerModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-hand-o-up"
    }), _vm._v(" Loan Sanction Letter\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "Loan EMI Card"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintCustomerEMIModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-book"
    }), _vm._v(" Loan EMI Card\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "Demand Promissory Note"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintDimandProbeshnoryNote(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sticky-note-o"
    }), _vm._v(" Demand Promissory Note\n                        ")])]) : _vm._e()])])])])
  }), 0)])])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "fileChargeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _c('form', {
    on: {
      "~submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect File Charge ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(8)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "processingFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(9), _vm._v(" "), _c('form', {
    on: {
      "~submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect Processing Fee ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(11)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "insuranceFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(12), _vm._v(" "), _c('form', {
    on: {
      "~submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect Insurance Fee ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(14)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(15), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "print"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.myhost === 'bullet.microfinancesoftware.in') ? _c('div', [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'fincare.13squad.com') ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(16), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px"
    }
  }, [_c('thead', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Customer Name ")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")\n                          ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Address ")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.mem.address) + ", " + _vm._s(_vm.mem.area) + "\n                          ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("District/State/Pincode ")]), _c('br'), _vm._v(" "), (_vm.mem.state) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.district) + ", " + _vm._s(_vm.mem.state.name) + " - " + _vm._s(_vm.mem.pin) + " ")]) : _vm._e()]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Contact No : ")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.seeRecord.member.mobile) + " ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(" Gender : ")]), _vm._v(_vm._s(_vm.mem.gender)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("DOB :")]), _vm._v(" " + _vm._s(_vm._f("myDate")(_vm.mem.dob)) + "\n                          ")]), _vm._v(" "), (_vm.mem.spouseName) ? _c('td', [_c('strong', [_vm._v("Spouse Name  ")]), _c('br'), _vm._v(" " + _vm._s(_vm.mem.spouseName))]) : _c('td', [_c('strong', [_vm._v("C/O ")]), _vm._v(" "), _c('br'), _vm._v(" " + _vm._s(_vm.mem.fatherName))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Co-Applicant : ")]), _vm._v(_vm._s(_vm.mem.guarantorName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Co-Applicant Address: ")]), _vm._v(_vm._s(_vm.mem.guarantorAddress))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Co-Applicant Phone: ")]), _vm._v(_vm._s(_vm.mem.guarantorPhone))])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Bank : ")]), _vm._v(" "), (_vm.mem.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Branch : ")]), (_vm.mem.bankBranch) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan ID :")]), _vm._v(" "), (_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Plan Name :")]), _vm._v(" " + _vm._s(_vm.pl.name))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Account Holder : ")]), _vm._v(_vm._s(_vm.mem.accountHolderName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Account Number : ")]), _vm._v(" "), (_vm.mem.accountNumber) ? _c('span', [_vm._v(_vm._s(_vm.mem.accountNumber))]) : _vm._e()]), _vm._v(" "), (_vm.myhost === 'https://sanidhyafincorp.com/') ? _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest / 12))]) : _vm._e()]) : _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("GST Include : ")]), _vm._v(_vm._s(_vm.pl.includeGst))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("IFSC : ")]), _vm._v(_vm._s(_vm.mem.ifsc))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan Amount :")]), _vm._v(" " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("File Charge : ")]), _vm._v(_vm._s(_vm.fileChargeFee(_vm.seeRecord)))])]), _vm._v(" "), _c('tr', [_vm._m(19), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Processing Fee :")]), _vm._v(" " + _vm._s(_vm.processingFee(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Insurance Fee :")]), _vm._v(" " + _vm._s(_vm.insuranceFee(_vm.seeRecord)))])]), _vm._v(" "), (_vm.pl.rateOfInterest) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Income (INR) : ")]), _vm._v(_vm._s(_vm.mem.incomeAmount))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Occupation : ")]), _vm._v(_vm._s(_vm.mem.jobType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Recovery type :")]), _vm._v(" " + _vm._s(_vm.pl.recoveryType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Amount to be Paid :")]), _vm._v(" "), (_vm.seeRecord.loanAmount) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.loanAmount))]) : _c('span', [_vm._v(" " + _vm._s(_vm.pl.amount))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Business Name : ")]), _vm._v(_vm._s(_vm.mem.businessName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Income Type : ")]), _vm._v(_vm._s(_vm.mem.incomeType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("No of Payments : ")]), _vm._v(" "), (_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.seeRecord.planCategory !== 'interest') ? _c('strong', [_vm._v(" Interest Amt : " + _vm._s(_vm.totalAmountToPay - _vm.planAmt(_vm.seeRecord)))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Minimum Income : ")]), _vm._v(_vm._s(_vm.mem.minAmount))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Purpose : ")]), (_vm.seeRecord.purpose) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.purpose.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Description : ")]), _vm._v(_vm._s(_vm.seeRecord.description))])]), _vm._v(" "), _c('tr', [_vm._m(20), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _c('center', [_vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Name : "), (_vm.seeRecord.guarantor) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.guarantor.name) + " (" + _vm._s(_vm.seeRecord.guarantor.code) + ")")]) : _vm._e()])]), _vm._v(" "), _c('td', [(_vm.seeRecord.guarantor) ? _c('span', [_vm._v("Address : " + _vm._s(_vm.seeRecord.guarantor.member_profile.address))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Contact Number : ")]), _vm._v(" "), (_vm.seeRecord.guarantor) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.guarantor.mobile) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Nominee Name : " + _vm._s(_vm.mem.nomineeName))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Nominee Mobile : ")]), _vm._v(_vm._s(_vm.mem.nomineePhone))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Nominee Dob : ")]), _vm._v(_vm._s(_vm.mem.nomineeDob))])])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px",
      "bottom": "20px"
    }
  }, [(_vm.myhost === 'progati.micromuneem.com' || _vm.myhost === 'bmcf.microfinancesoftware.in') ? _c('thead', [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23)]) : _c('thead', [_vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26)])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "printing"
  }, [_vm._v("Repayment Schedule Terms ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "11px"
    }
  }, [_c('thead', [_c('tr', [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_c('strong', [_vm._v("Interest")])]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_c('strong', [_vm._v("Principal")])]) : _vm._e(), _vm._v(" "), _vm._m(29)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.memberEmiRecords), function(memberEmiRecord) {
    return _c('tr', {
      key: memberEmiRecord.id
    }, [_c('td', [_vm._v(_vm._s(memberEmiRecord.emiNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(memberEmiRecord.emiDate))]), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_vm._v(_vm._s(memberEmiRecord.intrest))]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_vm._v(_vm._s(memberEmiRecord.principal))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(memberEmiRecord.total))])])
  }), 0)]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px",
      "bottom": "20px"
    }
  }, [(_vm.myhost === 'progati.micromuneem.com' || _vm.myhost === 'bmcf.microfinancesoftware.in') ? _c('thead', [_vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32)]) : _c('thead', [_vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35)])])]), _vm._v(" "), _c('agreementcontent')], 1) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _vm._m(36)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintCustomerEMIModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(37), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printCustomerEMI()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printCustomerEMI"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]), _vm._v(" "), _c('P', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Loan EMI Card")])]), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px"
    }
  }, [_c('thead', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Customer Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.name))]), _vm._v(" "), _c('td', [_vm._v("Customer Code ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.code))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contact No ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _c('td', [_vm._v("C/O ")]), _c('td', [(_vm.mem.spouseName) ? _c('span', [_vm._v(_vm._s(_vm.mem.spouseName))]) : _c('span', [_vm._v(_vm._s(_vm.mem.fatherName))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loan Amount - ")]), _vm._v(" "), _c('td', [_vm._v("₹ " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_vm._v("Plan Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pl.name) + " ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Number of EMI ")]), _c('td', [(_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("File Charge : ")]), _c('td', [_vm._v(_vm._s(_vm.fileChargeFee(_vm.seeRecord)))])]), _vm._v(" "), (_vm.myhost !== 'everyone.microfinancesoftware.in') ? _c('tr', [_c('td', [_vm._v("Total Amt Pay ")]), _c('td', [_vm._v(" " + _vm._s(_vm.totalAmountToPay))]), _vm._v(" "), _c('td', [(_vm.seeRecord.planCategory !== 'interest') ? _c('i', [_vm._v("Total Interest ")]) : _vm._e()]), _c('td', [(_vm.seeRecord.planCategory !== 'interest') ? _c('i', [_vm._v(" ₹ " + _vm._s(_vm.totalAmountToPay - _vm.planAmt(_vm.seeRecord)))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "font-size": "11px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in' && _vm.myhost !== 'usfinance.microfinancesoftware.in') ? _c('td', [_c('strong', [_vm._v("Interest")])]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in' && _vm.myhost !== 'usfinance.microfinancesoftware.in') ? _c('td', [_c('strong', [_vm._v("Principal")])]) : _vm._e(), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.memberEmiRecords), function(memberEmiRecord) {
    return _c('tr', {
      key: memberEmiRecord.id,
      staticStyle: {
        "border-width": "1px",
        "color": "black"
      }
    }, [_c('td', [_vm._v(_vm._s(memberEmiRecord.emiNo))]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(_vm._f("myDate")(memberEmiRecord.emiDate)))])]), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in' && _vm.myhost !== 'usfinance.microfinancesoftware.in') ? _c('td', [_vm._v(_vm._s(memberEmiRecord.intrest))]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in' && _vm.myhost !== 'usfinance.microfinancesoftware.in') ? _c('td', [_vm._v(_vm._s(memberEmiRecord.principal))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(memberEmiRecord.total))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
  }), 0)])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(45)]) : _vm._e()], 1) : _vm._e()])])])]), _vm._v(" "), _vm._m(46)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintCustomerModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(47), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printCustomer()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printCustomer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]), _vm._v(" "), _c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Loan Sanction Letter")]), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(48), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Contact No : ")]), _vm._v(_vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _vm._m(49)]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("DOB :")]), _vm._v(" " + _vm._s(_vm._f("myDate")(_vm.mem.dob)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(" Gender : ")]), _vm._v(_vm._s(_vm.mem.gender))]), _c('td')]), _vm._v(" "), (_vm.mem.spouseName) ? _c('tr', [_vm._m(50), _c('td', [_vm._v(" " + _vm._s(_vm.mem.spouseName))]), _c('td')]) : _c('tr', [_vm._m(51), _c('td', [_vm._v(" " + _vm._s(_vm.mem.fatherName))]), _c('td')]), _vm._v(" "), _c('tr', [_vm._m(52), _c('td', [_vm._v(" " + _vm._s(_vm.mem.address) + ", " + _vm._s(_vm.mem.area))]), _vm._v(" "), _vm._m(53), (_vm.mem.state) ? _c('td', [_vm._v(" " + _vm._s(_vm.mem.district) + ", " + _vm._s(_vm.mem.state.name) + " - " + _vm._s(_vm.mem.pin))]) : _vm._e()]), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Bank : ")]), _vm._v(" "), (_vm.mem.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Branch : ")]), (_vm.mem.bankBranch) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan ID :")]), _vm._v(" "), (_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Plan Name :")]), _vm._v(" " + _vm._s(_vm.pl.name))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Account Holder : ")]), _vm._v(_vm._s(_vm.mem.accountHolderName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Account Number : ")]), _vm._v(" "), (_vm.mem.accountNumber) ? _c('span', [_vm._v(_vm._s(_vm.mem.accountNumber))]) : _vm._e()]), _vm._v(" "), (_vm.myhost === 'https://sanidhyafincorp.com/') ? _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate Monthly(%) : " + _vm._s(_vm.pl.rateOfInterest / 12))]) : _vm._e()]) : _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("GST Include : ")]), _vm._v(_vm._s(_vm.pl.includeGst))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("IFSC : ")]), _vm._v(_vm._s(_vm.mem.ifsc))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan Amount :")]), _vm._v(" " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("File Charge : ")]), _vm._v(_vm._s(_vm.fileChargeFee(_vm.seeRecord)))])]), _vm._v(" "), _c('tr', [_vm._m(55), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Processing Fee :")]), _vm._v(" " + _vm._s(_vm.processingFee(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Insurance Fee :")]), _vm._v(" " + _vm._s(_vm.insuranceFee(_vm.seeRecord)))])]), _vm._v(" "), (_vm.pl.rateOfInterest) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Income (INR) : ")]), _vm._v(_vm._s(_vm.mem.incomeAmount))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Occupation : ")]), _vm._v(_vm._s(_vm.mem.jobType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Recovery type :")]), _vm._v(" " + _vm._s(_vm.pl.recoveryType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Amount to be Paid :")]), _vm._v(" "), (_vm.seeRecord.loanAmount) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.loanAmount))]) : _c('span', [_vm._v(" " + _vm._s(_vm.pl.amount))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Business Name : ")]), _vm._v(_vm._s(_vm.mem.businessName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Income Type : ")]), _vm._v(_vm._s(_vm.mem.incomeType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("No of Payments : ")]), _vm._v(" "), (_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.seeRecord.planCategory !== 'interest') ? _c('strong', [_vm._v(" Interest Amt : " + _vm._s(_vm.totalAmountToPay - _vm.planAmt(_vm.seeRecord)))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Minimum Income : ")]), _vm._v(_vm._s(_vm.mem.minAmount))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Purpose : ")]), (_vm.seeRecord.purpose) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.purpose.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Description : ")]), _vm._v(_vm._s(_vm.seeRecord.description))])]), _vm._v(" "), _c('tr', [_vm._m(56), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _c('center', [_vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])], 1)])]), _vm._v(" "), _c('tr', [_vm._m(57), _c('td', [(_vm.seeRecord.guarantor) ? _c('span', [_vm._v(" " + _vm._s(_vm.seeRecord.guarantor.name) + " ( " + _vm._s(_vm.seeRecord.guarantor.code) + " )")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Contact Number : ")]), (_vm.seeRecord.guarantor) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.guarantor.mobile) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Nominee Name : " + _vm._s(_vm.mem.nomineeName))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Nominee Mobile : ")]), _vm._v(_vm._s(_vm.mem.nomineePhone))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Nominee Dob : ")]), _vm._v(_vm._s(_vm.mem.nomineeDob))])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(58)]) : _vm._e()])])])]), _vm._v(" "), _vm._m(59)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(60), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.branchCode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.code))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Details")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-dark"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Plan Name ")]), _vm._v(" : " + _vm._s(_vm.pl.name))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Plan Type ")]), _vm._v(" : " + _vm._s(_vm.pl.planType))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Type of Interest")]), _vm._v(" : " + _vm._s(_vm.pl.typeOfInterest) + "\n                            ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Recovery Type")]), _vm._v(" : " + _vm._s(_vm.pl.recoveryType) + "\n                            ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Number of Payments")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.noOfPayments) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Amount")]), _vm._v(" : " + _vm._s(_vm.pl.amount))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Advance Installment")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.acvanceInstallment) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Panulty ")]), _vm._v(": " + _vm._s(_vm.pl.panulty))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Processing Fee ")]), _vm._v(": " + _vm._s(_vm.pl.processingFee) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("File Charge")]), _vm._v(" : " + _vm._s(_vm.pl.fileCharge))]), _vm._v(" "), (_vm.pl.created_by) ? _c('td', [_c('b', [_vm._v("Created By")]), _vm._v(" : " + _vm._s(_vm.pl.created_by.name) + "\n                            ")]) : _vm._e()])])]), _vm._v(" "), (_vm.seeRecord.member_id) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Member Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.member.name))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Type")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.planType))])]), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.centerCode))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.code))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Disbursement Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.disbursementDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("EMI Start Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.emiStartDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Payment Mode")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.paymentMode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.status))])])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(61)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewGroupMember"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(62), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(63), _vm._v(" "), _c('tbody', _vm._l((_vm.groupMembers), function(groupMem) {
    return _c('tr', {
      key: groupMem.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(groupMem.member.name))])]), _vm._v(" "), _c('td', [_c('a', [_vm._v(" " + _vm._s(groupMem.member.code))])])])
  }), 0)])])])])])])]), _vm._v(" "), _vm._m(64)])])]), _vm._v(" "), _c('advancesecurity', {
    attrs: {
      "advanceSecurityRecord": _vm.advanceSecurityRecord,
      "payment_ledgers": _vm.payment_ledgers
    }
  }), _vm._v(" "), _c('demandprobeshnarynote', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo,
      "pl": _vm.pl,
      "mem": _vm.mem
    }
  }), _vm._v(" "), _c('aadharagreementletter', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo,
      "pl": _vm.pl,
      "mem": _vm.mem
    }
  }), _vm._v(" "), _c('previousloanrecord', {
    attrs: {
      "seeRecord": _vm.seeRecordPrevious,
      "getCompanyRecord": _vm.getCompanyRecord,
      "memberloanplans": _vm.memberloanplans,
      "logo": _vm.logo
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Staff ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Individual Disbursement List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("LoanID ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Category")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Emi Type")]), _vm._v(" "), _c('th', [_vm._v("Plan Amt")]), _vm._v(" "), _c('th', [_vm._v("Dis Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Disbursement Dt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("EmiStartDate ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("EmiEndDate ")]), _vm._v(" "), _c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', [_vm._v("Alias")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Staff")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch Center")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-flat btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                      Task "), _c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("File Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Processing Fee Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Insurance Fee Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Loan Agreement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Guarantor Details : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("((সদস্যের স্বাক্ষর))")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(গ্যারেন্টারের স্বাক্ষর)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(শাখা সিল স্বাক্ষর সহ)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Sr. No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("EMI Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("((সদস্যের স্বাক্ষর))")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(গ্যারেন্টারের স্বাক্ষর)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(শাখা সিল স্বাক্ষর সহ)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("EMI Schedule Terms ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Sr. No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("EMI Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("EMI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Receive Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Received Amt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Staff Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "0px",
      "width": "95%",
      "font-size": "12px",
      "bottom": "18px"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Customer Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Spouse Name  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("C/O ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("District/State/Pincode ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Guarantor Details : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Name : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Loan Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Group Member Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Code")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6300980a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Loan/Disbursment.vue
// module id = 888
// module chunks = 0